import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { delftBlue, flame } from "@/theme/colors";
import ActivityIcon from "@/assets/Icon-1.svg";

const GuideStatsCards = ({ stats, onInviteGuide }) => {
  const { total = 0, active = 0, inactive = 0 } = stats || {};

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={{ xs: 1.5, sm: 2 }}
      sx={{
        alignSelf: "stretch",
      }}
    >
      <Card
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          width: "100%",
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          background: "white",
          borderRadius: 2,
          outline: `1px ${delftBlue[100]} solid`,
          outlineOffset: "-1px",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
          overflow: "visible",
          position: "relative",
        }}
      >
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0.75, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 14, sm: 15, md: 16 },
              fontFamily: "Audiowide, sans-serif",
              fontWeight: 400,
              display: "block",
              visibility: "visible",
            }}
          >
            Total Users
          </Typography>
        </Box>
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 20, sm: 18, md: 16 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              display: "block",
              visibility: "visible",
            }}
          >
            {total !== undefined && total !== null ? total : "N/A"}
          </Typography>
        </Box>
      </Card>

      <Card
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          width: "100%",
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          background: "white",
          borderRadius: 2,
          outline: `1px ${delftBlue[100]} solid`,
          outlineOffset: "-1px",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
          overflow: "visible",
          position: "relative",
        }}
      >
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0.75, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 14, sm: 15, md: 16 },
              fontFamily: "Audiowide, sans-serif",
              fontWeight: 400,
              display: "block",
              visibility: "visible",
            }}
          >
            Active Users
          </Typography>
        </Box>
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 20, sm: 18, md: 16 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              display: "block",
              visibility: "visible",
            }}
          >
            {active !== undefined && active !== null ? active : "N/A"}
          </Typography>
        </Box>
      </Card>

      <Card
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          width: "100%",
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          background: "white",
          borderRadius: 2,
          outline: `1px ${delftBlue[100]} solid`,
          outlineOffset: "-1px",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
          overflow: "visible",
          position: "relative",
        }}
      >
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0.75, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 14, sm: 15, md: 16 },
              fontFamily: "Audiowide, sans-serif",
              fontWeight: 400,
              display: "block",
              visibility: "visible",
            }}
          >
            Inactive Users
          </Typography>
        </Box>
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 20, sm: 18, md: 16 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              display: "block",
              visibility: "visible",
            }}
          >
            {inactive !== undefined && inactive !== null ? inactive : "N/A"}
          </Typography>
        </Box>
      </Card>

      <Button
        onClick={onInviteGuide}
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          width: "100%",
          padding: { xs: 1.5, sm: 2 },
          background: flame[500],
          borderRadius: 1.5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 1.5, sm: 2 },
          textTransform: "none",
          "&:hover": {
            background: flame[600],
          },
        }}
      >
        <Box
          component="img"
          src={ActivityIcon}
          alt="Invite User"
          sx={{
            width: { xs: 20, sm: 24 },
            height: { xs: 20, sm: 24 },
            objectFit: "contain",
          }}
        />
        <Typography
          sx={{
            textAlign: "center",
            color: "white",
            fontSize: { xs: 14, sm: 15, md: 16 },
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
          }}
        >
          Invite User
        </Typography>
      </Button>
    </Stack>
  );
};

export default GuideStatsCards;





